import React from "react";
import Dropzone from "react-dropzone-uploader";
import "react-dropzone-uploader/dist/styles.css";
import { useDispatch } from "react-redux";
import { dataUploadAddRequest } from "../../../../_redux/_actions";
import { dataUploadTableConfig } from "../../../pages/dataManagment/module.config";
// import UiSuccessAlertBox from "../UiSuceesAlertBox";

export default function UiDropZoneUploader(props) {

     const actionDispatch = useDispatch();
     // specify upload params and url for your files
     const getUploadParams = ({ meta, headers, fields }) => {
          return { url: `${dataUploadTableConfig?.dataUploadURL}?FileTypeId=${1}`};
     };

     // called every time a file's `status` changes
     const handleChangeStatus = ({ meta, file, remove}, status, fileWithMeta) => {
          
     };

     // receives array of files that are done uploading when submit button is clicked
     const handleSubmit = (files, allFiles) => {
          const data = JSON.parse(files[0]?.xhr?.response);
          const payload = {
               "dataFileTypeId": props?.fileType ? props?.fileType : '',
               "fileId": data?.data?.fileId ? data?.data?.fileId : '',
               "schemaId": props?.schemaType ? props?.schemaType : '',
               "actionTypeId": props?.actionTypeId ? props?.actionTypeId : '',
             }
             actionDispatch(dataUploadAddRequest(payload));
             allFiles.forEach(f => f.remove());
     };
     
     return (
          <>
               <Dropzone
                    getUploadParams={getUploadParams}
                    onChangeStatus={handleChangeStatus}
                    onSubmit={handleSubmit}
                    accept=".csv"
                    maxFiles={1}
                    disabled={props?.disable}
               />
          </>
     );
}
